/**
 * @ngdoc directive
 * @name ng.directive:ngRange
 * @element ANY
 * @function Suggestions directive
 */

const ngRange = ['$location', '$request', function ($location, $request) {
    return {
        link: function ( $scope, $item, $params ) {
            let query = $request.query;
           // console.log(query);
            $scope.range = {
                start: query.hasOwnProperty('d1') ? parseInt(query.d1): 0,
                finish: query.hasOwnProperty('d2') ? parseInt(query.d2) : 40,
                offset: (query.hasOwnProperty('d1') ? parseInt(query.d1): 0)/40*100,
                width: (query.hasOwnProperty('d2') ? parseInt(query.d2) : 40)/40*100 - ((query.hasOwnProperty('d1') ? parseInt(query.d1): 0)/40*100),
            };



            //console.log(query);
            //console.log($scope.range);
            let $name = $params.ngRange;
            $item.on('input', function ($event) {
                if ( $name === 'finish' && $scope.range[$name] < $scope.range.start + parseInt($params.step) ) {
                    $scope.range.finish = $scope.range.start + parseInt($params.step);
                }
                if ( $name === 'start' && $scope.range[$name] > $scope.range.finish - parseInt($params.step) ) {
                    $scope.range.start = $scope.range.finish - parseInt($params.step);
                }
                $scope.range.offset = $scope.range.start/parseInt($params.max)*100;
                $scope.range.width = $scope.range.finish/parseInt($params.max)*100 - $scope.range.offset;

                $scope.$apply();
                query.d1 = $scope.range.start;
                query.d2 = $scope.range.finish;
                delete query.page;
                //let location = $location.search(query);
                 window.location.href = window.location.pathname + '?' + $request.http_build_query(query);
            });

        }
    };
}];

export default ngRange;
